'use client';

import { AuthSplitLayout } from '@goodneighbor/ui';
import Link from 'next/link';
import { useState } from 'react';
import PartnerSignUpForm, { type RegistrationStep } from './PartnerSignUpForm';
import styles from './partnerSignUpContent.module.scss';
import { usePartnerAccountRedirect } from '@/hooks/usePartnerAccountRedirect';

export default function PartnerSignUpContent() {
  usePartnerAccountRedirect();

  const [step, setStep] = useState<RegistrationStep>('form');

  const isFormStep = step === 'form';

  const testimonial = {
    quote:
      'Good Neighbor makes it simple to bring volunteers together and keep events organized.',
    author: 'Taylor Reed',
    role: 'Community Organizer',
    location: 'Cincinnati, OH'
  };

  const heroImageSrc =
    'https://good-neighbor-web-assets.s3.us-east-2.amazonaws.com/sign-up-hero.png';

  return (
    <div className={styles.pageWrapper}>
      <AuthSplitLayout
        imageSrc={heroImageSrc}
        testimonial={testimonial}
        variant="single"
        className={styles.layoutContainer}
        logo={<span style={{ display: 'none' }} />}
        footerNode={
          <>
            <img
              src="/placeholder/1440px_Blue-Half-Circle-Footer_Spark_Center.svg"
              alt=""
              className={`${styles.footerDecoration} ${styles.footerDecorationDesktop}`}
              aria-hidden="true"
            />
            <img
              src="/placeholder/393px_Blue-Half-Circle_Spark_Offset.svg"
              alt=""
              className={`${styles.footerDecoration} ${styles.footerDecorationMobile}`}
              aria-hidden="true"
            />
          </>
        }
      >
        <main className={isFormStep ? styles.main : styles.verificationMain}>
          {step !== 'success' && isFormStep && (
            <div className={styles.header}>
              <h1 className={styles.title}>Partner Interest</h1>
              <p className={styles.welcomeText}>
                We are so excited you are here!
              </p>
              <p className={styles.subtitle}>
                Please complete the form below and our team will be in touch
                about partnership details and strategic planning.
              </p>
            </div>
          )}

          <PartnerSignUpForm onStepChange={setStep} />

          {isFormStep && (
            <div className={styles.footer}>
              Already have an account?{' '}
              <Link href="/partner" className={styles.loginLink}>
                Log in
              </Link>
            </div>
          )}
        </main>
      </AuthSplitLayout>
    </div>
  );
}
